export { default as theme } from 'prismjs/themes/prism-coy.css';
